module.exports = __webpack_public_path__ + "img/icon_order@2x.45151b2d.png";